import Main from '@App/Main';
import { AppConfig } from '@App/Main.types';
import { Configurator } from '@Config/Config';
import { ExternalController, ExternalControllerRaw } from '@Config/ExternalController';
import { isMobile } from '@Framework/deviceClassUtils';
import { getDeviceClass } from '@Framework/getDeviceClass';
import ScopedCssBaseline from '@material-ui/core/ScopedCssBaseline';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { globalMuiTheme } from '@Ui/theme/overrides';
import React from 'react';
import ReactDOM from 'react-dom';

export function renderLegacyClient() {
  const target = document.querySelector('#ods-client');
  if (target !== null) {
    window['odsClientRender'](target);
  }
}

interface OdsClientStartedProps {
  controller: ExternalControllerRaw;
}

export async function renderClient(containerElement: Element, config: AppConfig): Promise<void> {
  const parentNode = containerElement.parentNode;

  if (isMobile(getDeviceClass()) && parentNode?.['classList'].contains('o-CmsContent__bootstrap-container')) {
    parentNode?.['classList'].add('ods--is-mobile');
  }

  Configurator.setAll(config);

  ReactDOM.render(
    <MuiThemeProvider theme={globalMuiTheme}>
      <ScopedCssBaseline>
        <Main
          onStart={() => {
            const odsStartedEvent = new CustomEvent<OdsClientStartedProps>('odsClientStarted', {
              detail: {
                controller: ExternalController
              }
            });
            document.dispatchEvent(odsStartedEvent);
          }}
        />
      </ScopedCssBaseline>
    </MuiThemeProvider>,
    containerElement
  );
}
